import { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Cookies } from 'react-cookie';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindReportGrid, GetDate, ReverseFormatDate, setFocus, setTitle } from "../Common/Common";
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';

const EmptySorting = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const inputrefs = useRef([]);
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('warehouseName');
    const SalesPersonCode = cookies.get('warehouseCode')
    const [isUpdate, setIsUpdate] = useState(false)
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [SalesPersonID, setSalesPersonID] = useState('')
    const [CustomerData, setCustomerData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [InvoiceDate, setInvoiceDate] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [isSorted, setIsSorted] = useState(false);
    const [ReportTypeDropDown] = useState([
        {
            ReportTypeCode: 'Summarised',
            ReportType: 'Summarised'
        },
        {
            ReportTypeCode: 'DETAIL',
            ReportType: 'DETAIL'
        },
    ]);
    const [MenuText, setMenuText] = useState("Empty Sorting");
    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [modalTableData, setModalTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [MainItemName, setMainItemName] = useState('');
    const [ItemNoData, setItemNoData] = useState([]);
    const [InLueItem, setInLueItem] = useState();
    const [ItemRowNo, setItemRowNo] = useState(0);
    const [MainItem, setMainItem] = useState(0);
    const initialModalState = {
        Item: '',
        PartialEmptySortingID: '0',
        Quantity: '0',
        InLueItem: []
    };
    const [modal, setModal] = useState(initialModalState);

    const [showModal, setShowModal] = useState(false)
    const handleClose = () => {

        setModal(initialModalState);
        setSaveData((prevState) => ({
            ...prevState,  // Spread the previous state
            ItemDetails: [],  // Add new item to ItemDetails
        }));
        setShowModal(false);
        getInvoiceData();
    }
    const handleShow = () => setShowModal(true);
    const [InvoiceNo, setInvoiceNo] = useState('');
    const [SalesPerson, setSalesPerson] = useState('');

    const [FilterData, setFilterData] = useState({
        ReportType: ReportTypeDropDown[0].ReportTypeCode,
        PageIndex: "1",
        InvoiceNo: "",
        Customer: "",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        InvoiceDateFrom: "",
        InvoiceDateTo: "",
    });
    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }

    useEffect(() => {
        setTitle('EmptySorting', setOpen);
        setFocus('txtInvoiceNo');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    useEffect(() => {
        getInvoiceData();
    }, [FilterData.PageIndex, isUpdate]);


    const getInvoiceData = (Type = 'S', PI = `${FilterData.PageIndex}`) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: PI,
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Operation/GetDataForEmptySorting`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({

                });
            }
            setIsLoading(false)
        });
    }

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                InvoiceNo: "",
                Customer: "",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
                InvoiceDateFrom: "",
                InvoiceDateTo: "",
                Quantity: 0
            }
        );

        setTableData({});
        setFocus('txtInvoiceNo');
        setIsUpdate(!isUpdate)
    }

    const [SaveData, setSaveData] = useState({
        ItemDetails: [],
    });

    const [AddExtraItem, SetAddExtraItem] = useState({
        Item: "",
        Quantity: 0,
        InLueItem: []
    });

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getInvoiceData();
    }

    const handleChange1 = (event, value) => {
        getInvoiceData("S", value);
    };

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: SalesPersonPre.split(':')[0].trim(),
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }
    let CustomerArr = []
    for (let i = 0; i < CustomerData.length; i++) {
        let mydata = CustomerData[i]?.values
        CustomerArr.push(mydata)
    };

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPersonANDWarehouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    let SalesPersonArr = []
    for (let i = 0; i < SalesPerson.length; i++) {
        let mydata = SalesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };
    const [itemQty, setItemQty] = useState("")

    const handleModal = async (ID) => {
        setIsSorted(false)
        setInvoiceNo(ID.InvoiceNo);
        setInvoiceDate(ID.InvoiceDate)
        setSalesPersonID(ID?.Edit)
        setItemQty(ID.ItemQuantity)
        setMainItem(ID.Item);
        setMainItemName("Empty Sorting Quantity");
        handleShow();
        handleAddNewItem();
        setInLueItem(ID)
        GetInLueItem(ID)
    }

    const GetInLueItem = async (ID = InLueItem) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString,
            InvoiceDate: ID.InvoiceDate,
            InvoiceNo: ID.InvoiceNo,
            MainItem: ID.Item,
            SalesPerson: ID?.Edit?.split(':')[0]?.trim(),
            PageIndex: "1",
            Type: "S"
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Operation/GetPartialEmptySortingData`, { ...data }, (res) => {

            if (res.Status === 'SUCCESS') {
                setModalTableData({
                    ...res
                });
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setModalTableData({

                });
            }
            setIsLoading(false)
        });
    }

    const HandleReceivedQuantity = () => {
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...SaveData,
            Token: Token,
            LoginUserCode: loginCodeString,
            InvoiceDate: InvoiceDate ? InvoiceDate : "",
            MainItem: MainItem,
            SalesPerson: SalesPersonID || '',
            isSorted: isSorted,
            ItemDetails: SaveData.ItemDetails.map((item, index) =>
                index === ItemRowNo
                    ? {
                        ...item,
                        InLueItem: modalTableData.Data.map(entry => ({
                            Visible: false,
                            Item: entry.SubItemCode,
                            Quantity: entry.Quantity
                        }))
                    }
                    : item
            )
        };

        post(`${API_SERVER}/api/Operation/UpdateReceivedQuantity`, { ...data }, (res) => {
            setIsLoading(false);
            if (res.Status === 'SUCCESS') {
                if (res.Message !== "") {
                    AlertBox(res.Status, res.Message, res.Focus);
                }
                handleClose();
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, "");
            }
            setIsLoading(false);
        })
    }

    const getEmptyItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetSortingEmptiesItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }

    const handleAddNewItem = () => {
        let Item = AddExtraItem.Item;
        let Quantity = AddExtraItem.Quantity;
        setSaveData(prevSaveData => {
            return {
                ...prevSaveData,
                ItemDetails: [...prevSaveData.ItemDetails, AddExtraItem]
            };
        });

        SetAddExtraItem({
            ...AddExtraItem,
            Item: "",
            Quantity: 0,
            InLueItem: []
        });

        AddEmptyItem(Quantity, Item);
    };

    const AddEmptyItem = async (Quantity, Item) => {
        //Empty Item
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token: Token, LoginUserCode: loginCodeString, ItemNo: Item, Customer: SaveData.Customer, SalesPerson: SaveData.SalesPerson
        }
        post(`${API_SERVER}/api/Operation/GetEmptyItem`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                res.Data.forEach((item, index) => {
                    let EmptyItem = {};
                    EmptyItem.Item = item.ItemNo;
                    EmptyItem.ItemPrice = item.ItemPrice;
                    EmptyItem.InHandQuantity = item.InHandQuantity * Quantity;
                    EmptyItem.OrderQuantity = 0;
                    EmptyItem.RequiredQuantity = 0;
                    EmptyItem.ReturnQuantity = item.InHandQuantity * Quantity;
                    EmptyItem.NetAmount = 0;
                    EmptyItem.MainItem = Item;
                    EmptyItem.IsMainItem = false;
                    EmptyItem.IsOrderItem = false;
                    EmptyItem.IsItemEnable = false;
                    EmptyItem.ItemGroup = item.ItemGroupCode;
                    EmptyItem.InLueItem = [];
                    setSaveData(prevSaveData => ({
                        ...prevSaveData,
                        ItemDetails: [...prevSaveData.ItemDetails, EmptyItem]
                    }));
                });
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox("error", res.Message, "");
            }
            setIsLoading(false);

        })
    }

    //Handle  Add
    const HandleAddInLue = (res) => {

        if (modal.Item === "") {
            AlertBox("error", "Please enter item.", "txtInLueEmptyItemNo");
        }
        else if (modal.Quantity === '0') {
            AlertBox("error", "Please enter quantity.", "txtInLueQuantity");
        }
        else if (parseInt(modal.Quantity, 10) === 0) {
            AlertBox("error", "Quantity should be greater than zero.", "txtInLueQuantity");
        }
        if (parseInt(modal.Quantity, 10) > parseInt(res?.PendingQuantity, 10)) {
            AlertBox("error", `Quantity cannot be greater than pending quantity (${res?.PendingQuantity}).`, "txtInLueQuantity");
            console.log(res?.PendingQuantity,)
        }
        else {
            const totalQuantity = SaveData?.ItemDetails[ItemRowNo].InLueItem.reduce((sum, item) => sum + parseInt(item.Quantity, 10), 0);
            if (totalQuantity + parseInt(modal.Quantity, 10) > parseInt(itemQty, 10)) {
                AlertBox("error", `Total quantity cannot greater than available Item quantity (${itemQty}).`, "txtInLueQuantity");
            } else {
                (() => {
                    const loginCodeString = String(LoginUserCode);
                    let data = {
                        Token: Token,
                        PartialEmptySortingID: modal.PartialEmptySortingID,
                        LoginUserCode: loginCodeString,
                        InvoiceDate: InvoiceDate || "",
                        InvoiceNo: InvoiceNo || "",
                        MainItem: MainItem,
                        SalesPerson: SalesPersonID,
                        ItemDetails: [
                            {
                                
                                Item: modal.Item,
                                Quantity: modal.Quantity
                            }
                        ]
                    }
                    post(`${API_SERVER}/api/Operation/InsertPartialEmptySorting`, { ...data }, (res) => {
                        if (res.Status === 'SUCCESS') {
                            GetInLueItem();
                        } else if (res.Message === "EXPIRED") {
                            navigate('/Login')
                        } else if (res.Message !== "") {
                            AlertBox("error", res.Message, "");
                        }
                        setIsLoading(false)
                    })
                })()

                HandleResetInLue();
                setFocus("txtInLueEmptyItemNo");
            }
        }
    }
// Handle Reset
    const HandleResetInLue = () => {
        setModal(
            {
                Index: 0,
                Action: "",
                Item: "",
                Quantity: 0
            }
        );

    }

    //Handle  Edit
    const handleEditInLueModal = (item) => {
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token: Token,
            LoginUserCode: loginCodeString,
            PartialEmptySortingID: item.Edit
        }
        post(`${API_SERVER}/api/Operation/EditPartialEmptySortingData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setModal({
                    PartialEmptySortingID: item.Edit,
                    Item: editRecordJson[0]['SubItemCode'],
                    Quantity: editRecordJson[0]['Quantity'],
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }

    //Handle delete 
    const handleDeleteInLueModal = async (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, PartialEmptySortingID: ID.Del
        }
        post(`${API_SERVER}/api/Operation/DeletePartialEmptySortingData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                GetInLueItem();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message,)
            }
            setIsLoading(false);
        })
    }
    return (
        <>
            <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
                <section className="section dashboard">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="content-box">
                                <div className="heading-box">
                                    <div className="heading">
                                        <h6 className="m-0 font-weight-bold text-primary">{MenuText ? MenuText : "Empty Sorting Quantity"}</h6>
                                    </div>
                                </div>
                                <div className="form-box service-content-area">
                                    <div className="row align-items-end">

                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="fields">
                                                <AutoCompleteBox
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("txtInvoiceDateFrom") };
                                                    }}
                                                    disabled={SalesPersonCode ? true : false}
                                                    label='WareHouse / Sales Person'
                                                    placeholder="WareHouse / Sales Person"
                                                    maxLength='50'
                                                    options={SalesPersonArr}
                                                    id='txtSalesPerson'
                                                    required={false}
                                                    ignore_common={true}
                                                    onFocus={() => getSalesPerson()}
                                                    inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                    onInputChange={(event, newInputValue) => {
                                                        HandleChange('SalesPerson', newInputValue)
                                                        setSalesPersonPre(newInputValue)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-6">
                                            <div className="fields">
                                                <label className="form-label">Empty Sorting Date </label>
                                                <DatePicker selected={ReverseFormatDate(GetDate(0))}
                                                    disabled='disabled'
                                                    id='txtStockReturnDate'
                                                    className="form-control"
                                                    placeholderText='Select Stock Transfer Date'
                                                    dateFormat={'dd-MMM-yyyy'}
                                                    autoComplete='off'

                                                    maxDate={new Date()}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            setFocus('btnSearch');
                                                        };
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 mt-1">
                                            <div className="lms-new-button text-center">
                                                <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                    <i className="bi bi-search" /> Search
                                                </button>
                                                <button className="button reset-btn" onClick={handleClearData} >
                                                    <i className="bi bi-arrow-clockwise" /> Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} currentPageNo={currentPageNo} handleEditData={handleModal}
                    handleChange1={handleChange1} handleClearData={handleClearData} />
                {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            </main>
            <Modal show={showModal} size="lg" data-backdrop="static" >
                <Modal.Header closeButton backdrop="static" keyboard={false} onHide={handleClose}>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        <div className="modal-header-title" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                            <h5 className="modal-title modal-title-large" id="addModalLabel" style={{ fontSize: '1.5rem', fontWeight: '700', color: 'black', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <i className="fas fa-box-open" style={{ fontSize: '1.2rem' }}></i> {MainItemName}
                            </h5>
                            <h5 className="modal-title modal-title-detail" style={{ fontSize: '1.1rem', fontWeight: '500', color: '#6c757d', display: 'flex', gap: '20px' }}>
                                <span><b>Invoice Date:</b> ({InvoiceDate})</span>
                                <span><b>Item:</b> ({MainItem})</span>
                            </h5>
                        </div>
                    </Modal.Title>


                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-lg-8'>
                                    <div className="form-group text-start mb-3" >
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtInLueQuantity") };
                                                }}
                                                label='Item'
                                                placeholder="Empty Item"
                                                maxLength='50'
                                                options={ItemNoArr}
                                                PopperComponent={(props) => (
                                                    <div {...props} style={{ zIndex: 1501, position: 'absolute', width: '36%' }} />
                                                )}
                                                id='txtInLueEmptyItemNo'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getEmptyItemNo()}
                                                inputValue={modal.Item ? modal.Item : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setModal({ ...modal, Item: newInputValue });
                                                }}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-2'>
                                    <div className="form-group text-start mb-3" >
                                        <div className="fields">
                                            <label className="form-label ">Quantity <span className="Required">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                ref={ref => (inputrefs.current['Quantity'] = ref)}
                                                style={{ textAlign: 'right' }}
                                                id='txtInLueQuantity'
                                                value={modal.Quantity}
                                                onChange={(e) => setModal({ ...modal, Quantity: e.target.value.replace(/\D/g, "") })}
                                                onFocus={(e) => { e.target.select(); }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-2  mt-3'>
                                    <button type="button" id="btnAddInLue" class="btn btn-success" onClick={() => HandleAddInLue()} style={{ margin: '5px', minWidth: '30px' }}>Add <i className="bi bi-plus"></i></button>
                                </div>
                            </div>
                        </div>

                        <BindReportGrid
                            tableData={modalTableData}
                            // setFilterData={setFilterData}
                            //  filterData={FilterData}
                            //  currentPageNo={currentPageNo}
                            handleEditData={handleEditInLueModal}
                            handleDeleteData={handleDeleteInLueModal}
                        //   handleChange1={handleChange1}
                        //    handleClearData={handleClearData}
                        />

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="row align-items-center justify-contant-between">
                        {/* Checkbox with label */}
                        <div className="col">
                            <div className="form-group">
                                <div className="form-check m-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isSortedCheckbox"
                                        checked={isSorted}
                                        onChange={(e) => setIsSorted(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="isSortedCheckbox">
                                        Sorted
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Button */}
                        <div className="col">
                            <button
                                type="button"
                                disabled={!isSorted}
                                className="btn btn-success"
                                onClick={() => HandleReceivedQuantity()}
                                style={{ margin: '5px', minWidth: '80px' }}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default EmptySorting;